import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {useEffect} from 'react';

export const ThemeUpdater = ({listitem}) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        editor.update(() => {
            const config = editor._config.theme;
            config.list = {
                ...config.list, // Keep the existing theme
                listitem: listitem // Update the theme
            };
        });
    }, [listitem, editor]);

    return null;
};
